import { motion } from "framer-motion";
import Emblem from "./Emblem";

export default function BigCTA() {
    return (
        <section
            data-testid="big-cta"
            className="relative overflow-hidden bg-black py-28 md:py-48 border-t border-white/10"
        >
            {/* Massive rainbow paint splash behind */}
            <div className="absolute inset-0 pointer-events-none opacity-30">
                <div className="absolute -top-40 -left-40 w-[70vw] h-[70vw] rounded-full rainbow-bg blur-3xl" />
                <div className="absolute -bottom-40 -right-40 w-[60vw] h-[60vw] rounded-full rainbow-bg blur-3xl" />
            </div>

            <div className="relative z-10 px-6 md:px-16 flex flex-col items-start">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
                    className="flex items-center gap-4 mb-10"
                >
                    <Emblem size={64} spin />
                    <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/60">
                        [ Ch. 07 ] · The Call
                    </span>
                </motion.div>

                <motion.h2
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
                    className="font-display uppercase text-[14vw] md:text-[10vw] lg:text-[9vw] leading-[0.85] tracking-[-0.04em] max-w-6xl"
                >
                    Pick up the
                    <br />
                    <span className="rainbow-text">phone.</span>
                    <br />
                    Change the wall.
                </motion.h2>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{
                        duration: 0.9,
                        delay: 0.2,
                        ease: [0.19, 1, 0.22, 1],
                    }}
                    className="mt-14 flex flex-col md:flex-row gap-6 md:items-center"
                >
                    <a
                        href="tel:5616984044"
                        data-testid="big-cta-phone"
                        className="group glass-btn relative inline-flex items-center gap-4 border border-white px-8 py-6 font-mono text-sm md:text-base tracking-[0.24em] uppercase overflow-hidden"
                    >
                        <span className="absolute inset-0 rainbow-bg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                        <span className="relative z-10 flex items-center gap-5 group-hover:text-black transition-colors">
                            <span className="w-2 h-2 rounded-full bg-[#00FF85] blink" />
                            Call 561·698·4044
                            <span className="text-xl leading-none transition-transform duration-500 group-hover:translate-x-2">
                                ↗
                            </span>
                        </span>
                    </a>
                    <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-white/50 max-w-sm">
                        Paul answers. Or calls back inside the hour. Free
                        estimates. Licensed & insured across South Florida.
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
